const zoomOut = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><rect width="14" height="14" x="1" y="1" stroke-width="1.2" rx="1.5"/><path stroke-width="1.5" d="M11.5 8h-7"/></svg>',
};

export { zoomOut as default };
